import React from 'react'
import ProductPage from "./ProductPage"

export const Admin = () => {
    return (
        <div>
            <ProductPage/>
        </div>
    )
}
